export const SCORE_RULES = {
  CORRECT_ANSWER: 1,
  INPUT_CORRECT_ANSWER: 0.5,
  INPUT_INCORRECT_ANSWER: -0.5,
};

function normalizeAnswerIds(answer) {
  return (Array.isArray(answer) ? answer : [answer])
    .map((item) => String(item || "").trim())
    .filter(Boolean);
}

export function isTestAnswerCorrect(question, selectedOption) {
  if (!question || !selectedOption) return false;

  const selectedAnswers = normalizeAnswerIds(selectedOption);
  const correctAnswers = normalizeAnswerIds(question.correctAnswer);
  if (!selectedAnswers.length || selectedAnswers.length !== correctAnswers.length) return false;

  return correctAnswers.every((answer) => selectedAnswers.includes(answer));
}

export function isDropdownAnswerCorrect(question, dropdownValues) {
  const correctAnswers = question?.correctAnswers;
  if (!correctAnswers || typeof correctAnswers !== "object") return false;

  return Object.keys(correctAnswers).every(
    (key) => dropdownValues?.[key] === correctAnswers[key]
  );
}

export function isDropdown2AnswerCorrect(question, dropdownValues) {
  const dropdowns = Array.isArray(question?.dropdowns) ? question.dropdowns : [];
  if (!dropdowns.length || !dropdownValues || typeof dropdownValues !== "object") return false;

  return dropdowns.every(
    (dropdown, idx) => dropdownValues[`drop${idx}`] === String(dropdown?.correctAnswer || "")
  );
}

export function getDropdown2AnswerScoreDelta(question, dropdownValues) {
  const dropdowns = Array.isArray(question?.dropdowns) ? question.dropdowns : [];
  if (!dropdowns.length || !dropdownValues || typeof dropdownValues !== "object") return 0;

  return dropdowns.reduce((sum, dropdown, idx) => {
    const isCorrect = dropdownValues[`drop${idx}`] === String(dropdown?.correctAnswer || "");
    return sum + (isCorrect ? SCORE_RULES.INPUT_CORRECT_ANSWER : SCORE_RULES.INPUT_INCORRECT_ANSWER);
  }, 0);
}

export function isInputAnswerCorrect(question, inputValues) {
  const correctAnswers = Array.isArray(question?.correctAnswers)
    ? question.correctAnswers
    : [];

  if (!correctAnswers.length || !Array.isArray(inputValues)) return false;
  if (correctAnswers.length !== inputValues.length) return false;

  return correctAnswers.every(
    (answer, idx) => String(inputValues[idx] || "").trim() === String(answer || "").trim()
  );
}

export function isLogicalSequenceAnswerCorrect(question, selectedOrder) {
  const correctOrder = Array.isArray(question?.correctOrder)
    ? question.correctOrder.map((item) => String(item || "").trim())
    : [];
  const order = Array.isArray(selectedOrder)
    ? selectedOrder.map((item) => String(item || "").trim())
    : [];

  if (!correctOrder.length || correctOrder.length !== order.length) return false;

  return correctOrder.every((item, idx) => item === order[idx]);
}

export function getInputAnswerScoreDelta(question, inputValues) {
  const correctAnswers = Array.isArray(question?.correctAnswers)
    ? question.correctAnswers
    : [];

  if (!correctAnswers.length || !Array.isArray(inputValues)) return 0;

  return correctAnswers.reduce((sum, answer, idx) => {
    const isCorrect = String(inputValues[idx] || "").trim() === String(answer || "").trim();
    return sum + (isCorrect ? SCORE_RULES.INPUT_CORRECT_ANSWER : SCORE_RULES.INPUT_INCORRECT_ANSWER);
  }, 0);
}
